module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external "office-ui-fabric-react"
// module id = 65
// module chunks = 0